export * from './DeleteRecordModal'
